import { render, staticRenderFns } from "./platformDecoration.vue?vue&type=template&id=04e9a482&scoped=true&"
import script from "./platformDecoration.vue?vue&type=script&lang=js&"
export * from "./platformDecoration.vue?vue&type=script&lang=js&"
import style0 from "./platformDecoration.vue?vue&type=style&index=0&id=04e9a482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9a482",
  null
  
)

export default component.exports